<template>
  <div class="fourFeature">
    <Menu></Menu>
    <div id="fourFeature" style="margin-top: 80px;">
    	<div class="four-feature-first-screen">
			<div class="postion-screen">
				<img src="../assets/img/fourFirstscreen.jpg" alt="" class="pcStyle"/>
				<img src="../assets/img/sida285.jpg" alt="" class="mbStyle"/>
				<div class="four-feature-first-screen-box">
					<div>四大功能</div>
					<div>Four major functions</div>
				</div>
			</div>
		</div>
		<div class="four-feature-second-screen">
			<div class="postion-screen">
				<img src="../assets/img/fourSecondscreen.jpg" alt="" class="pcStyle"/>
				<img src="../assets/img/fourSecondscreenMb.jpg" alt="" class="mbStyle"/>
				<div class="four-feature-second-screen-box">
					<div class="four-feature-second-screen-left">
						<div>Information digitization platform</div>
						<div>信息数字化平台</div>
						<div>利用物联网、移动互联网、云计算等相关技术，全方位实时数据监控</div>
						<div>实现对生活垃圾分类投放，分类运输及处理进行全方位实时监控，减少对环境的二次污染</div>
					</div>
					<div class="four-feature-second-screen-right pcStyle">
						<div>
							<img src="../assets/img/indoumation.png" alt="" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="four-feature-second-screen">
			<div class="postion-screen">
				<img src="../assets/img/map.jpg" alt="" class="pcStyle"/>
				<img src="../assets/img/mapMb.jpg" alt="" class="mbStyle"/>
				<div class="map-text">实时管控调度<br/>垃圾分类设施、<br class="pcStyle"/>人员、车辆</div>
			</div>
		</div>
		<div class="four-feature-fourth-screen">
			<div class="four-feature-fourth-screen-box">
				<div class="four-feature-one">
					<div></div>
					<div>回收分拣加工区</div>
					<div>进行废品的回收分拣加工生成再生资源</div>
				</div>
				<div class="four-feature-two">
					<img src="../assets/img/gou.jpg" alt=""/>
				</div> 
				<div class="four-feature-one">
					<div></div>
					<div>集散交易区</div>
					<div>再生资源的集散地和交易中心</div>
				</div>
				<div class="four-feature-two">
					<img src="../assets/img/re.jpg" alt="" style="transform: scale(1.1);"/>
				</div>
				<div class="four-feature-one">
					<div></div>
					<div>拆解处置区</div>
					<div>对废旧物资进行拆解、处置</div>
				</div>
				<div class="four-feature-two">
					<img src="../assets/img/changzi.jpg" alt="" style="transform: scale(1.52);"/>
				</div>
			</div>
		</div>
    </div>
	<Footer></Footer>
  </div>
</template>
<script>
  import axios from "axios";
  import Menu from './menu';
  import Footer from './footer';
  import Swiper,{Navigation, Pagination,Autoplay,Mousewheel} from 'swiper'
  Swiper.use([Navigation, Pagination,Autoplay,Mousewheel])
  export default {
    name: 'fourFeature',
    components:{
     Menu,
	 Footer
    },
     data () {
      return {
		
      };
    },
	mounted(){
		
	},
	methods: {
		
	},
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/fourFeature.scss';

</style>


// WEBPACK FOOTER //
// src/components/fourFeature.vue